<template>
  <div class="flipResult-overlay-black">
    <div class="flipResult-barh-fadeOutDelay">
      <div class="flipResult-animation-cont flipResult-fadeIn-animation">
        <div class="flipResult-barh-container-relative">
          <div class="title-anim">
            <div class="content-score">
              <div class="result-box">
                <div class="flipResult-barh-expandIn-1 barh-player">
                  <div class="scroll-number" >
                    <span> {{ score.playerSum1 }} </span>
                    <span> {{ score.playerSum2 }} </span>
                    <span :class="classWinLossTotal('PLAYER')"> {{ score.playerCardTotal }} </span>
                  </div>
                </div>
                <div class="flipResult-barh-expandIn-1 barh-banker">
                  <div class="scroll-number">
                    <span> {{ score.bankerSum1 }} </span>
                    <span> {{ score.bankerSum2 }} </span>
                    <span :class="classWinLossTotal('BANKER')"> {{ score.bankerCardTotal }} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="barh-result">
            <div class="flipResult-barh-container-card card-player "
              :class="classWinLoss('PLAYER')"
            >
              <div class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation; animation-delay: 1160ms, 1380ms; animation-duration: 300ms, 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 1380ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-black" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 1380ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.playerCard2Suit)"
                  >
                    {{ score.playerCard2Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                    <component :is="classSuit(score.playerCard2Suit)" />
                  </div>
                </div>
              </div>
              <div class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation; animation-delay: 0ms, 180ms; animation-duration: 300ms, 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 180ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-red" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 180ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.playerCard1Suit)"
                  >
                    {{ score.playerCard1Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-2">
                    <component :is="classSuit(score.playerCard1Suit)" />
                  </div>
                </div>
              </div>
              <div v-if="score.playerCard3Number !== ''" class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation-3; animation-delay: 2420ms, 2680ms; animation-duration: 1000ms, 1000ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 2680ms; animation-duration: 1600ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-black" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 2680ms; animation-duration: 1000ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.playerCard3Suit)"
                  >
                    {{ score.playerCard3Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-3">
                    <component :is="classSuit(score.playerCard3Suit)" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flipResult-barh-container-card card-banker"
              :class="classWinLoss('BANKER')"
            >
              <div class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation; animation-delay: 630ms, 830ms; animation-duration: 300ms, 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 830ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-red" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 830ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.bankerCard1Suit)"
                  >
                    {{ score.bankerCard1Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-2">
                    <component :is="classSuit(score.bankerCard1Suit)" />
                  </div>
                </div>
              </div>
              <div class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation; animation-delay: 1790ms, 2030ms; animation-duration: 300ms, 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 2030ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-red" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 2030ms; animation-duration: 300ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.bankerCard2Suit)"
                  >
                    {{ score.bankerCard2Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-4">
                    <component :is="classSuit(score.bankerCard2Suit)" />
                  </div>
                </div>
              </div>
              <div v-if="score.bankerCard3Number !== ''" class="flipResult-barh-card" style="animation-name: flipResult-barh-card-fadeIn, flipResult-barh-card-cardAnimation-3; animation-delay: 3450ms, 3730ms; animation-duration: 1000ms, 1000ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                <div class="flipResult-barh-card-back fr-main-bg" style="animation-name: flipResult-barh-card-backContentAnimation; animation-delay: 3730ms; animation-duration: 1600ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-back-image"></div>
                </div>
                <div class="flipResult-barh-card-front flipResult-barh-card-number-black" style="animation-name: flipResult-barh-card-contentAnimation; animation-delay: 3730ms; animation-duration: 1000ms; animation-fill-mode: forwards; animation-timing-function: ease-out;">
                  <div class="flipResult-barh-card-number"
                    :class="classNumberColor(score.bankerCard3Suit)"
                  >
                    {{ score.bankerCard3Number }}
                  </div>
                  <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-3">
                    <component :is="classSuit(score.bankerCard3Suit)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="skipAnimBtn" tabindex="-1">Lần rút tiếp theo</div> -->
  </div>
</template>

<script>
import SpadeSign from '@assets/icons/spade-sign.svg';
import HeartSign from '@assets/icons/heart-sign.svg';
import ClubSign from '@assets/icons/club-sign.svg';
import DiamondSign from '@assets/icons/diamond-sign.svg';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SpadeSign,
    // eslint-disable-next-line vue/no-unused-components
    HeartSign,
    // eslint-disable-next-line vue/no-unused-components
    ClubSign,
    // eslint-disable-next-line vue/no-unused-components
    DiamondSign,
  },
  props: {
    table: {
      type: String,
      default: ""
    },
    score: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    classSuit: function (value) {
      switch (value) {
        case 1:
          return SpadeSign;
        case 2:
          return ClubSign;
        case 3:
          return DiamondSign;
        case 4:
          return HeartSign;
      }
    },
    classWinLoss: function (value) {
      return (this.score.result === value || this.score.result === 'TIE') ? "barh-win" : "barh-loss";
    },
    classWinLossTotal: function (value) {
      return (this.score.result === value || this.score.result === 'TIE') ? "" : "barh-loss";
    },
    classNumberColor: function (suit) {
      return suit > 2 ? "flipResult-barh-card-number-red" : "flipResult-barh-card-number-black";
    },
  }
}
</script>

<style>

</style>
